import axios from "axios";
import { TTP_API_URL } from "Config";

export const getEventIds = ({ token, userId }) => {
  const requestUrl = `${TTP_API_URL}/event/event/get-events-access-for-contact`;
  //const requestUrl = `https://api.rc2.tamtam.pro/event/event/get-events-access-for-contact`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      //access_token: "2a4277f4634da916de2e1906c895bbbb10c1ba21",
      contact: userId
    }
  });
};

export const getEvents = ({ token, ids }) => {
  const requestUrl = `${TTP_API_URL}/event/event`;
  //const requestUrl = `https://api.rc2.tamtam.pro/event/event`;

  const filter = [
    {
      property: "id",
      operator: "in",
      value: ids
    }
  ];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      //access_token: "2a4277f4634da916de2e1906c895bbbb10c1ba21",
      filter: JSON.stringify(filter),
      limit: 50,
      start: 0
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/event.js